<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "İşlem Geçmişleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        title: "İŞLEM GEÇMİŞLERİ",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "İŞLEM GEÇMİŞLERİ",
          active: true,
        }],
        isLoading: false,
        detailSearch:true,
        form:{
            user_id:"",
            startdate:'',
            startdateend:''
        },
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {
            },
            sort: [
            {
                field: '',
                type: '',
            },
            ],
            page: 1,
            perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        url: "/reports/islem-gecmisleri",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
        },
        columns: [ 
        {
          label: 'Müşteri Kullanıcı Adı',
          field: 'username',
          sortable: false,
        },
        {
          label: 'Müşteri İsim Soyisim',
          field: 'fullname',
          sortable: false,
        },
         {
          label: 'İşlem',
          field: 'content',
          sortable: false,
        },
         {
          label: 'İşi Yapan',
          field: 'name',
          sortable: false,
        },
        {
          label: 'İşlem Tarihi',
          field: 'created_at',
             type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss', // expects 2018-03-16
          dateOutputFormat: 'dd.MM.yyyy HH:mm', // outputs Mar 16th 2018
        },
        ],
        userList:[],
    };
  },
  mounted() {
    this.loadItems()
    this.getUsers()
  },
  methods: {
    getUsers(){
        this.$http.post('/users?output=one&fields=id,name')
        .then(response => {
            this.userList = [
                { id: "", name: 'Tümü' },
                ...response.data
            ];
        })
    },
  
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.info = response.info
      
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              info: res.data.info,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
 
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

     <div class="row mb-3">
        <div class="col-md-6 offset-lg-6 text-end">
           <div class="button-items mx-2">
             
             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
          </div>
      </div>
     <Transition  name="fade" v-if="detailSearch">
        <div class="offset-lg-4 col-lg-8">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-md-4">
                    <div class="row">
                        <div class="mb-3">
                          <label>İşlemi Yapan</label>
                          <v-select
                              label="name" 
                              v-model="form.user_id"
                              :options="userList" 
                              :reduce="data => data.id">
                              <span slot="no-options">Sonuç Bulunamadı</span>
                          </v-select>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-xl-8">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <label class="d-flex justify-content-between">İşlem Tarih Aralığı
                              <span 
                                v-if="form.startdate || form.startdateend" 
                                class="text-danger" 
                                @click="form.startdate= '' ;form.startdateend= ''">
                                temizle</span>
                              </label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form.startdate">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form.startdateend">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4 " style="align-self: end;">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <label>-</label>
                            <div class="button-items">
                                <button 
                                  type="submit"
                                  class="btn btn-primary w-100 "   
                                  >
                                  Sorgula
                                </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote" 
                :line-numbers="true"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>